import React from "react";
import {Button, Popover, PopoverContent, PopoverHandler,} from "@material-tailwind/react";

export default function ElapsedHelper() {

  return <div>
    <Popover placement="bottom"
             animate={{
               mount: {scale: 1, y: 0},
               unmount: {scale: 0, y: 25},
             }}>

      <PopoverHandler>
        <Button>Open Helper</Button>
      </PopoverHandler>
      <PopoverContent>
        [Method] <br/>
        All : 모든 Method 종류 조회 <br/>
        train_get_model_download_url : fl-core 에서 모델 다운로드 URL 호출 <br/>
        train_model_download : S3 에서 모델 다운로드 <br/>
        training : 실제 학습 <br/>
        train_get_model_upload_url : fl-core 에서 모델 업로드 URL 호출 <br/>
        train_model_upload : S3 에 모델 업로드<br/>
        train_model_upload_result : 최종 결과 fl-core 에 업로드 <br/>
        total_training_time : 총 학습 시간 <br/>
        evaluation_get_model_download_url : fl-core 에서 모델 다운로드 URL 호출 <br/>
        evaluation_model_download : S3 에서 모델 다운로드 <br/>
        evaluation : 실제 평가 <br/>
        evaluation_model_upload_result : 최종 결과 fl-core 에 업로드 <br/>
        total_evaluation_time : 총 평가 시간 <br/>
      </PopoverContent>

    </Popover>
  </div>
}